module.exports = __webpack_public_path__ + "img/menu-requests.3affd752.svg";